import { ColumnHeader, IColumnHeader, Table } from '@aon/aon-tws-common-ui';
import React from 'react';
import { ISurveyQuestionEditModel } from '../../../models';
import { isDimensionQuestionSelectable } from '../../../utilities/DimensionHelper';
import DimensionQuestionTableRow from './DimensionQuestionTableRow';

const tableColumns: IColumnHeader[] = [
	{
		label: 'Question',
		field: 'Question',
	},
	{
		label: 'Response Option',
		field: 'Response Option',
	},
];

export interface IDimensionQuestionTableProps {
	questions: ISurveyQuestionEditModel[];
	allSelected: boolean;
	allowSelection: boolean;
	selectedQuestions: ISurveyQuestionEditModel[];
	onAllQuestionsSelected: (value: boolean) => void;
	onSingleQuestionSelected: (question: ISurveyQuestionEditModel, isSelected: boolean) => void;
}

const DimensionQuestionTable = ({
	questions,
	allSelected,
	allowSelection,
	selectedQuestions,
	onAllQuestionsSelected,
	onSingleQuestionSelected,
}: IDimensionQuestionTableProps) => {
	const getColumns = () => {
		if (allowSelection) {
			return tableColumns;
		} else {
			return [{ label: '', field: '' }, ...tableColumns];
		}
	};

	return (
		<Table lastalign='left' selectable='True'>
			<ColumnHeader
				columns={getColumns()}
				selectable={allowSelection}
				showHeaderCheckbox={true}
				headerCheckboxChecked={allSelected}
				onHeaderCheckboxChange={() => onAllQuestionsSelected(!allSelected)}
			/>
			<tbody>
				{questions.map((question) => {
					const isQuestionSelectable = isDimensionQuestionSelectable(question);
					return (
						<DimensionQuestionTableRow
							key={question.id}
							question={question}
							isSelected={
								(allSelected && isQuestionSelectable) ||
								selectedQuestions.find((q) => q.surveyQuestionId === question.surveyQuestionId) !== undefined
							}
							allowSelection={allowSelection && isQuestionSelectable}
							onQuestionSelectionChange={onSingleQuestionSelected}
						/>
					);
				})}
			</tbody>
		</Table>
	);
};

export default DimensionQuestionTable;
